import React from 'react';
import type { User } from '@core/api/user';
import { ChangePasswordDialog, ProfileDialog } from '@core/components';
import UserMenu from './UserMenu';

export interface LayoutUserAccountProps {
  variant?: 'appbar' | 'sidebar';
  user: User | null;
  profileOpen: boolean;
  onProfileClick: () => void;
  onCloseProfile: () => void;
  changePasswordOpen: boolean;
  onChangePasswordClick: () => void;
  onCloseChangePassword: () => void;
  isDarkMode: boolean;
  onThemeToggle: () => void;
  onLogout: () => Promise<void>;
}

const LayoutUserAccount: React.FC<LayoutUserAccountProps> = ({
  variant = 'appbar',
  user,
  profileOpen,
  onProfileClick,
  onCloseProfile,
  changePasswordOpen,
  onChangePasswordClick,
  onCloseChangePassword,
  isDarkMode,
  onThemeToggle,
  onLogout,
}) => (
  <>
    <UserMenu
      variant={variant}
      user={user || undefined}
      onLogout={onLogout}
      onProfileClick={onProfileClick}
      onChangePasswordClick={onChangePasswordClick}
      onThemeToggle={onThemeToggle}
      isDarkMode={isDarkMode}
    />

    <ProfileDialog open={profileOpen} onClose={onCloseProfile} />

    <ChangePasswordDialog
      open={changePasswordOpen}
      onClose={onCloseChangePassword}
    />
  </>
);

export default LayoutUserAccount;
